// store Reschedule id
export function getRescheduleId(type, data) {
  return {
    type: type,
    payload: data,
  };
}

// store Reschedule data
export function getRescheduleDataApi(type, data) {
  return {
    type: type,
    payload: data,
  };
}


// store Reschedule fullscreen Enabled
export function getRescheduleFullScreenEnb(type, data) {
  return {
    type: type,
    payload: data,
  };
}
